import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { COMMON_MESSAGES } from 'appRootPath/messages';
import { FileObject, MODAL_OPTIONS } from 'appRootPath/shared/global-meta-data';
import { ViewDocsModalComponent } from 'appRootPath/shared/view-docs-modal/view-docs-modal.component';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})

export class CpDocumentsHelperService {
    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal
    ) { }
    /**
     * Show docs in a modal using ViewDocsModalComponent
     * @param document document object as FileObject
     * @param documentName name of the document
     * @param fileFetchApi the cold observable which makes the API call
     */
    fetchAndShowDocsInModal(document: FileObject, documentName: string, fileFetchApi) {

        // Check if old file object is present in the document.
        if (!document.file_key) {
            this.toastr.error(COMMON_MESSAGES.DOCUMENT_KEY_NOT_FOUND);
            return;
        }
        // tslint:disable-next-line: deprecation
        fileFetchApi.subscribe((fileUrlResp: any) => {
            const modalRef = this.modalService.open(ViewDocsModalComponent, MODAL_OPTIONS);
            modalRef.componentInstance.docsToView = [{
                title: documentName,
                document_url: fileUrlResp
            }];
        });
    }

    /**
     * Given document name and document URL, show PDF doc in modal
     */
    showDocsInModal(documentName: string, documentUrl: string) {
        const modalRef = this.modalService.open(ViewDocsModalComponent, MODAL_OPTIONS);
        modalRef.componentInstance.docsToView = [{
            title: documentName,
            document_url: documentUrl
        }];
    }

}


